"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _searchParamsUtils = require("../../../utils/searchParamsUtils");

var _pluralizeUtils = require("../../../utils/pluralizeUtils");

var _date = require("../../../utils/date");

var WishlistItemDate = function WishlistItemDate(props) {
  var date = props.date,
      nights = props.nights,
      flex = props.flex;
  var dateFormatted = (0, _date.formatDate)(date, 'dd MMMM');
  var nightsFormatted = nights && (0, _searchParamsUtils.uniqNights)(nights).join('-');
  var nightsCounter = nights && (0, _pluralizeUtils.pluralizeNights)(nights.to);
  var flexDates = flex ? " \xB1 ".concat(flex, " \u0434\u043D\u044F") : '';
  return /*#__PURE__*/_react["default"].createElement(StyledWishlistItemDate, null, "\u0441", ' ', /*#__PURE__*/_react["default"].createElement("span", null, dateFormatted, flexDates), ' ', "\u043D\u0430\xA0", /*#__PURE__*/_react["default"].createElement("span", null, nightsFormatted, " ", nightsCounter));
};

var StyledWishlistItemDate = _styledComponents["default"].div.withConfig({
  displayName: "WishlistItemDate__StyledWishlistItemDate",
  componentId: "sc-x9fjvn-0"
})(["margin-bottom:5px;height:16px;color:#676767;span{color:#000;}"]);

var _default = WishlistItemDate;
exports["default"] = _default;